
var phoenixTag = phoenixTag || {};

phoenixTag.utilities = phoenixTag.utilities || function ($) {

    function setBackground(elm) {
        if($(elm).length) {
            $(elm).each(function() {
                var current = $(this);
                var imageSrc = $('img', current).attr('src');
                $(current).prepend('<div class="js-background__container"></div>')
                $('.js-background__container', current).attr('style', 'background-image:url(' + imageSrc + ');');

                $(current).addClass('js-background');
                $('.js-background__container', current).addClass('js-background__container--visible');
            });
        }
    }

    function departmentOverlay(elm) {
        var overlay = $('#department-overlay');
        var trigger = $(elm);
        var close = $('.department-overlay__close', overlay);

        $(trigger).click(function(){
            $(overlay).addClass('active');
        });
        $(close).click(function(){
            $(overlay).removeClass('active');
        });
    }

    function mediaOverlay(elm) {
    }

    function productList(elm) {
        if($('.product-list').length) {
            var list = $('.product-list')

            if($('.product-list__product', list).length) {

                $('.product-list__product', list).each(function() {
                    var current = $(this);
                    var textBlock = $('.product-list__block--text', current);

                    var  height = $(textBlock).outerHeight();
                    var offset = '-' + height/2 + 'px';
                    $(textBlock).css('margin-top', offset);
                    $(textBlock).addClass('visible');
                });

            }
        }
    }

    // public functions:
    return {
        setBackground: setBackground,
        departmentOverlay: departmentOverlay,
        mediaOverlay: mediaOverlay,
        productList: productList

    };

} (jQuery);